export default __webpack_public_path__ + "static/DigiGuide_logo_3_cropped-1711a781e9754e76ad76ccd55b52ac55.png";